/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Welcome_TitleInputs */

const es_walkthrough_welcome_title = /** @type {(inputs: Walkthrough_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Bienvenido a Nexata!`)
};

const en_walkthrough_welcome_title = /** @type {(inputs: Walkthrough_Welcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Nexata!`)
};

/**
* | output |
* | --- |
* | "Welcome to Nexata!" |
*
* @param {Walkthrough_Welcome_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_welcome_title = /** @type {((inputs?: Walkthrough_Welcome_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Welcome_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_welcome_title(inputs)
	return en_walkthrough_welcome_title(inputs)
});
export { walkthrough_welcome_title as "walkthrough.welcome_title" }